<!--
 * @Date: 2023-12-29 11:18:32
 * @Author: jm
 * @LastEditTime: 2024-07-26 17:19:05
 * @LastEditors: jm
 * @FilePath: \playfulshinetop\src\components\TopBar.vue
 * @Description: 
-->
<template>
  <div class="top">
    <a class="right" href="home.html">
      <img src="@/assets/images/title_pic.png" alt="" class="title_pic" />
    </a>
  </div>
</template>

<script>
export default {
  name: "TopBar",
  props: {},
};
</script>

<style lang="scss" scoped>
.top {
  overflow: hidden;
  display: flex;
  align-items: center;
  padding: 30px 50px 0px;
  background: #ff6464;
  .right {
    width: 549px;
    height: 70px;
    display: block;
  }
}
</style>
